import { Card, CardContent, Chip, Grid } from '@mui/material';
import { Icon, Typography } from '@zenput/legacy-ui-components';
import { AttachmentList } from '@zenput/feature-nav-drawer';
import Linkify from 'linkify-react';
import unescape from 'lodash/unescape';
import { isNative } from '../../../shared/utils/is';

const { Body, Subheader } = Typography;

const BannerDetails = (props) => {
    const { baseUrl, company, created_user, date_scheduled, title, message, attachments } = props;

    const parsedAttachments = attachments.map((attachment) => ({
        path: attachment.path,
        contentType: attachment.content_type,
        fileName: attachment.file_name,
        fileSize: attachment.file_size,
        pathLarge: attachment.path_large,
        pathMedium: attachment.path_medium,
        pathSmall: attachment.path_small
    }));

    const toLocaleDateStringOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    };
    const dateScheduled = new Date(date_scheduled);

    return (
        <Card className="bannerDetails">
            <CardContent className="content">
                <Grid container justifyContent="center" spacing={1} direction="row">
                    <Grid item xs={10}>
                        {company && <Chip className="companyName" label={company} size="small" />}
                    </Grid>

                    <Grid item xs={10}>
                        <Grid container justifyContent="space-between" direction="row">
                            <Grid item>
                                <Grid container direction="row">
                                    <Grid item>
                                        <Icon variant="df-account" className="icon" size={14} />
                                    </Grid>
                                    <Grid item>
                                        <Body>{created_user}</Body>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <Body>{dateScheduled.toLocaleDateString('en-US', toLocaleDateStringOptions)}</Body>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={10}>
                        <Subheader className="title">{title}</Subheader>
                    </Grid>

                    <Grid item xs={10}>
                        <Body className="message">
                            <Linkify as="span">{unescape(message)}</Linkify>
                        </Body>
                    </Grid>

                    <Grid item xs={10}>
                        {attachments && (
                            <AttachmentList baseUrl={baseUrl} attachments={parsedAttachments} isNative={isNative()} />
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default BannerDetails;
